import React from "react";
import { InputSwitch } from "primereact/inputswitch";

function ToggleField({ title, help, checked, onChange, disabled, footer }) {
  return (
    <>
      {footer ? (
      <div className="flex align-items-center gap-3">
         <InputSwitch className="switch-small" checked={!!checked} onChange={(e) => onChange(e.value)} disabled={disabled} />
        <div>
          <p className="product-form-toggle-title text-sm font-medium">{title}</p>
        </div>

      </div>
      ) : (
      <div className="product-form-toggle">
        <div>
          <p className="product-form-toggle-title text-sm font-medium">{title}</p>
          {help ? <p className="product-form-toggle-help text-xs">{help}</p> : null}
        </div>
        <InputSwitch className="switch-small" checked={!!checked} onChange={(e) => onChange(e.value)} disabled={disabled} />
      </div>
      )}
    </>
  );
}

export default ToggleField;
